import type { StateCreator } from "zustand";
import type { Resolution } from "./pick-resolution";

export interface PanelResolutionSlice {
    panelResolutions: Record<string, Record<string, Resolution>>;
    setPanelResolution: (groupId: string, panelId: string, resolution: Resolution) => void;
    clearPanelResolution: (groupId: string, panelId: string) => void;
}

export const createPanelResolutionSlice: StateCreator<PanelResolutionSlice, [], [], PanelResolutionSlice> = (set) => ({
    panelResolutions: {},
    setPanelResolution: (groupId, panelId, resolution) =>
        set((state) => ({
            panelResolutions: {
                ...state.panelResolutions,
                [groupId]: { ...state.panelResolutions[groupId], [panelId]: resolution },
            },
        })),
    clearPanelResolution: (groupId, panelId) =>
        set((state) => {
            const group = state.panelResolutions[groupId];
            if (!group) return state;
            const rest = { ...group };
            delete rest[panelId];
            return { panelResolutions: { ...state.panelResolutions, [groupId]: rest } };
        }),
});
